export const cloner = {
  id: null,
  // eventGroupId: null, // We may need some kind of modal dialog to ask about this...
  questions: {
    _cloneMode: Array,
    id: null,
    dependentQuestionId: null,
    eventId: null,
    values: {
      _cloneMode: Array,
      id: null,
      questionId: null
    }
  },
  locations: {
    _cloneMode: Array,
    eventId: null
  },
  seatings: {
    _cloneMode: Array,
    id: null,
    eventId: null
  },
  costs: {
    _cloneMode: Array,
    id: null,
    eventId: null
  },
  blockedGuestTypes: {
    _cloneMode: Array,
    eventId: null
  }
}
